import { type User } from "@microsoft/microsoft-graph-types";

import { type UserInfo } from "./types";

export const getUserInfo = (
  user: User | undefined,
  cmps?: [string, string][]
): UserInfo => {
  const userBuCode = user?.onPremisesExtensionAttributes?.extensionAttribute14 // is cmp
    ? user?.onPremisesExtensionAttributes?.extensionAttribute13
        ?.replace(".", "")
        .concat(
          user?.onPremisesExtensionAttributes?.extensionAttribute14?.replace(
            "EXO",
            ""
          ) ?? ""
        )
    : user?.onPremisesExtensionAttributes?.extensionAttribute13?.replace(
        "STO.",
        ""
      );
  const userCmp = cmps?.find((el) => el[0] === userBuCode)?.[0];
  return {
    emailId: user?.mail ?? "",
    displayName: user?.displayName,
    surname: user?.surname,
    givenName: user?.givenName,
    countryCode: user?.usageLocation ?? "",
    language: `${user?.preferredLanguage}-${user?.usageLocation}`,
    shortId: user?.mailNickname ?? "",
    buCode: userCmp,
  };
};
